module.exports = __webpack_public_path__ + "media/images/countryrect/va-db75f171af3e4ee2a278c7c7c11b5d5f.svg";